module.exports = __webpack_public_path__ + "static/media/north-geen-line-overlay.cde9252f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/01/assets/north-geen-line-overlay.svg
// module id = 795
// module chunks = 0